import { Dialog } from "primereact/dialog"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Button } from "primereact/button"
import { useContext, useState } from "react"
import GpraHistoryDetail from "./GpraHistoryDetail"
import { useEffect } from "react"
import { UserContext } from "../../../context/userContext"
import axios from "axios"
import { gpraUrl } from "../../../config/microservicesUrls"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { LoaderMedium } from "../../../components/Loaders"
import { DateTime } from "luxon"
import { useQuery, gql } from "@apollo/client"

const GpraHistory = ({ visible, setVisible }) => {
  const [recordView, setRecordView] = useState({})
  const [showDetail, setShowDetail] = useState(false)
  const [loading, setLoading] = useState(false)
  const [recordHistory, setRecordHistory] = useState([])

  const userCtx = useContext(UserContext)

  useEffect(() => {
    if (userCtx.current_participant_id && userCtx.participant_membership_id) {
      setLoading(true)
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokens.getGpraToken()}`,
        },
        params: {
          gpra_participant_uuid: userCtx.current_participant_id,
          gpra_membership_uuid: userCtx.participant_membership_id,
        },
      }
      axios
        .get(`${gpraUrl()}${endpoints.GPRA_RECORD_HISTORY}`, config)
        .then(async (response) => {
          if (response.status === 200) {
            Promise.all(await formatData(response.data)).then((res) => {
              const newRecords = [...recordHistory]
              newRecords.push(res[0])
              setRecordHistory(newRecords)
            })
            setLoading(false)
          } else {
            setRecordHistory({})
            setLoading(false)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const GET_USER = gql`
    query user($staff_id: ID!, $organization_id: ID!) {
      user(staff_id: $staff_id, organization_id: $organization_id) {
        staff_name_first
        staff_name_last
      }
    }
  `
  const staffQuery = useQuery(GET_USER, {
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
    },
    skip: true,
  })

  const getStaffName = async (staff_id) => {
    if (!staff_id || !userCtx?.session?.user?.organization_id) {
      console.warn("Staff ID or Organization ID are incomplete.")
      return null
    }

    const res = await staffQuery.refetch({
      staff_id: staff_id,
      organization_id: userCtx.session.user.organization_id,
    })
    const { staff_name_first, staff_name_last } = res.data.user
    return `${staff_name_first} ${staff_name_last}`
  }

  const formatData = async (data) => {
    return data?.map(async (d) => {
      return {
        gpra_record_id: d.gpraRecord?.gpraRecordId,
        gpra_participant_uuid: d.gpraRecord?.gpraParticipantUuid,
        gpra_participant_name: `${userCtx.participant_name_first} ${userCtx.participant_name_last}`,
        gpra_organization_uuid: d.gpraRecord?.organizationUuid,
        gpra_organization_name: userCtx.session.user.organization_name,
        gpra_membership_uuid: d.gpraRecord?.gpraMembershipUuid,
        completed_date: DateTime.fromObject(d.completed_date, {
          zone: "utc",
        })
          .toLocal()
          .toLocaleString(DateTime.DATETIME_SHORT),
        completed_by: await getStaffName(d.completedBy),
        view: (
          <Button
            label="View"
            onClick={() => {
              setRecordView(d)
              setShowDetail(true)
            }}
          />
        ),
      }
    })
  }

  if (loading || staffQuery.loading) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <Dialog
      visible={visible}
      onHide={() => setVisible(false)}
      style={{ width: "900px" }}
      modal
      header={"GPRA History"}
    >
      <DataTable
        value={recordHistory}
        paginator
        rows={5}
        rowsPerPageOptions={[5, 10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
      >
        <Column field="gpra_record_id" header="Id" style={{ width: "15%" }} />
        <Column
          field="gpra_participant_name"
          header="Participant"
          style={{ width: "23%" }}
        />
        <Column
          field="gpra_organization_name"
          header="Organization"
          style={{ width: "23%" }}
        />
        <Column
          field="completed_date"
          header="Completed date"
          style={{ width: "23%" }}
        />
        <Column
          field="completed_by"
          header="Completed By"
          style={{ width: "30%" }}
        />
        <Column field="view" style={{ width: "15%" }} />
      </DataTable>
      <GpraHistoryDetail
        visible={showDetail}
        setVisible={setShowDetail}
        gpra_record={recordView}
      />
    </Dialog>
  )
}
export default GpraHistory
